import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ModalCustom',
  props: /*@__PURE__*/_mergeModels({
    modelValue: {
        type: Boolean,
        required: true
    },
    closeable: {
        type: Boolean,
        default: true
    },
    icon: {
        type: Boolean,
        default: true
    },
    divider: {
        type: Boolean,
        default: true
    }
}, {
    "modelValue": {
    type: Boolean
},
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['close'], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const model = _useModel(__props, "modelValue");

const emit = __emit;

function close () {
    model.value = false;
    emit('close');
}

function getIconColumnWidth (isXs: boolean): number {
    return isXs ? 2 : 1;
}

function getMessageColumnWidth (isXs: boolean): number {
    if (!props.icon) {
        return 12;
    }
    return isXs ? 10 : 11;
}

__expose({
    close
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": model.value,
    "max-width": "1030",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "pa-2 pt-2 pb-1" }, {
            default: _withCtx(() => [
              (__props.closeable)
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    "no-gutters": "",
                    justify: "end"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_v_col, {
                        cols: "auto",
                        class: "pointer px-2",
                        onClick: close
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: 18,
                            class: "ico-45-deg",
                            color: "szGrey"
                          }, {
                            default: _withCtx(() => _cache[0] || (_cache[0] = [
                              _createTextVNode(" $tagClose ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_ripple]
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "sz-white sz-primary-grey--text" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  (__props.icon)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        cols: getIconColumnWidth(_ctx.$vuetify.display.xs),
                        class: "pl-0 pl-md-5"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            size: 37,
                            color: "szRed"
                          }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                              _createTextVNode(" $alert ")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["cols"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_col, {
                    cols: getMessageColumnWidth(_ctx.$vuetify.display.xs)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, { "no-gutters": "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _renderSlot(_ctx.$slots, "header")
                            ]),
                            _: 3
                          }),
                          (__props.divider)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12",
                                class: "my-5"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_divider)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "f-18 sz-primary-grey--text font-weight-regular"
                          }, {
                            default: _withCtx(() => [
                              _renderSlot(_ctx.$slots, "footer")
                            ]),
                            _: 3
                          })
                        ]),
                        _: 3
                      })
                    ]),
                    _: 3
                  }, 8, ["cols"])
                ]),
                _: 3
              })
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["model-value"]))
}
}

})